<div class="container">

<app-header-dialog [iconName]="'card_giftcard'">
  Produto 
</app-header-dialog>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !_productService.spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div class='bread-crumb' flex>
    <mat-icon color="accent">arrow_right</mat-icon>
    {{ _productService.breadCrumb(_productService.localTitle) }}
  </div>

  <mat-tab-group>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>card_giftcard</mat-icon>
        <div>Produto</div>
      </ng-template>

      <div class='tab-content-name'>
        <mat-form-field class="name-width" appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="productForm.controls.name"
            autocomplete="off">
          <mat-error *ngIf="productForm.controls.name.hasError('required')">
            O Nome é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="name-width" appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="productForm.controls.name_en"
            autocomplete="off">
          <mat-error *ngIf="productForm.controls.name_en.hasError('required')">
            Name is madatory
          </mat-error>
        </mat-form-field>

      </div>

      <div class='tab-content-text'>

        <div style='margin-right: 10px; width:50%;'>
          <ckeditor [config]="{ 
                        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="productForm.controls.text" [editor]="Editor"></ckeditor>
          <mat-error *ngIf="productForm.controls.text.hasError('required')">
            O Texto é obrigatório
          </mat-error>
        </div>

        <div style='margin-left: 10px; width:50%;'>
          <ckeditor [config]="{ 
                        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList' ] }"
            [formControl]="productForm.controls.text_en" [editor]="Editor"></ckeditor>
          <mat-error *ngIf="productForm.controls.text_en.hasError('required')">
            Text is mandatory
          </mat-error>
        </div>
      </div>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

        <button mat-raised-button (click)='insert()' [disabled]="productForm.invalid" *ngIf="!_productService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>

        <button mat-raised-button (click)='update()' [disabled]="productForm.invalid" *ngIf="_productService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>

      </div>


    </mat-tab>


    <mat-tab *ngIf='_productService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>local_bar</mat-icon>
        <div>Eventos</div>
      </ng-template>

      <div class='tab-content-itens'>

        <div style='background-color: whitesmoke; padding:10px 10px 0 10px; margin:10px 0 10px 0;'>
          <mat-form-field class="select-width" appearance="outline">
            <mat-label>Eventos</mat-label>
            <mat-select (ngModelChange)='selectItem($event)' [errorStateMatcher]="matcher"
              [formControl]="itemForm.controls.event_id">

              <mat-option *ngFor="let event of _productService.arrayEvents" [value]="event.id">
                {{ event.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="itemForm.controls.event_id.hasError('required')">
              Selecione um evento
            </mat-error>
          </mat-form-field>

          <button mat-raised-button (click)='addItem()' [disabled]="!selectedItemOk">
            <mat-icon class='icon-add'>add_circle_outline</mat-icon>
          </button>
        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="_productService.productItensDataSource" matSort matSortActive="event_name"
          style='height:400px; overflow:auto; margin: 0;'>

          <!-- icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>local_bar</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="event_name">
            <mat-header-cell *matHeaderCellDef> Evento </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.event_name }} </mat-cell>
          </ng-container>


          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='removeItem(element)' style='background-color: whitesmoke;'>
                <mat-icon class="icon-delete">delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayedItemColumns"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedItemColumns;">
          </mat-row>

        </mat-table>
        <!-- END TABLE -->

      </div>

    </mat-tab>


    <mat-tab *ngIf='_productService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>image_search</mat-icon>
        <div>Imagem</div>
      </ng-template>

      <div class='tab-content-img'>

        <mat-card>

          <h4>Imagem Principal (pt)</h4>

          <div class='img-input'>
            <input #file type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_productService.previewImage($event)" />
          </div>
          <div class="post-image">
            <img [src]="_productService.storedImage" *ngIf="_productService.storedImage">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>

        </mat-card>

        <mat-card>
          <h4>Imagem Principal (en)</h4>

          <div class='img-input'>
            <input #file_en type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_productService.previewImage_en($event)" />
          </div>
          <div class="post-image">
            <img [src]="_productService.storedImage_en" *ngIf="_productService.storedImage_en">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file_en.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>

        </mat-card>

        <mat-card>

          <h4>Imagem Botão (pt)</h4>

          <div class='img-input'>
            <input #file_button type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_productService.previewImageButton($event)" />
          </div>
          <div class="post-image">
            <img [src]="_productService.storedButton" *ngIf="_productService.storedButton">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file_button.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>

        </mat-card>

        <mat-card>

          <h4>Imagem Botão (en)</h4>

          <div class='img-input'>
            <input #file_button_en type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_productService.previewImageButton_en($event)" />
          </div>
          <div class="post-image">
            <img [src]="_productService.storedButton_en" *ngIf="_productService.storedButton_en">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)='file_button_en.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>
          </div>

        </mat-card>

      </div>

      <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <button mat-raised-button (click)='update()' [disabled]="productForm.invalid" *ngIf="_productService.isEdit">
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </mat-tab>

    <mat-tab *ngIf='_productService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>attach_money</mat-icon>
        <div>Valores</div>
      </ng-template>

      <mat-tab-group>

        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class='tab-icon'>layers</mat-icon>
            <div>Lotes</div>
          </ng-template>

          <div class='tab-content-lot'>

            <!-- TABLE  matSortActive="name" matSortDirection='asc' matSortDisableClea'true' -->
            <mat-table [dataSource]="_productLotService.productLotsDataSource" matSort>

              <!-- icon Column -->
              <ng-container matColumnDef="icon">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>layers</mat-icon>
                </mat-cell>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef> Lote </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.name }} </mat-cell>
              </ng-container>

              <!-- Date Until Column -->
              <ng-container matColumnDef="until_date">
                <mat-header-cell *matHeaderCellDef> Até </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.until_date.seconds*1000 | date: 'dd-MM-yyyy' }} </mat-cell>
              </ng-container>

              <!-- edit Column -->
              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='openLotDialog(element)' style='background-color: whitesmoke;'>
                    <mat-icon class='icon-info'>
                      info_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>


              <!-- delete Column -->
              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='deleteLot(element)' style='background-color: whitesmoke;'>
                    <mat-icon class="icon-delete">delete_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>

              <!-- Header -->
              <mat-header-row *matHeaderRowDef="displayedLotColumns; sticky: true;"></mat-header-row>

              <!-- Row -->
              <mat-row *matRowDef="let row; columns: displayedLotColumns;">
              </mat-row>

            </mat-table>
            <!-- END TABLE -->
          </div>

          <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
            <button mat-raised-button (click)='openLotDialog(null)'>
              <mat-icon class='icon-add'>add_circle_outline</mat-icon>
            </button>
          </div>
        </mat-tab>

        <mat-tab *ngIf='_productService.isEdit'>
          <ng-template mat-tab-label>
            <mat-icon class='tab-icon'>layers_clear</mat-icon>
            <div>Reembolso </div>
          </ng-template>

          <div class='tab-content-lot'>

            <!-- TABLE  matSortActive="name" matSortDirection='asc' matSortDisableClear='true' -->
            <mat-table [dataSource]="_refundService.refundDataSource" matSort>

              <!-- icon Column -->
              <ng-container matColumnDef="icon">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>layers_clear</mat-icon>
                </mat-cell>
              </ng-container>

              <!-- Date Until Column -->
              <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef> Até </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.date.seconds*1000 | date: 'dd-MM-yyyy' }} </mat-cell>
              </ng-container>

              <!-- pecent Column -->
              <ng-container matColumnDef="percent">
                <mat-header-cell *matHeaderCellDef> % </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.percent }} </mat-cell>
              </ng-container>

              <!-- edit Column -->
              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='openRefundDialog(element)' style='background-color: whitesmoke;'>
                    <mat-icon class='icon-info'>
                      info_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>


              <!-- delete Column -->
              <ng-container matColumnDef="delete">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <a mat-button (click)='deleteRefund(element)' style='background-color: whitesmoke;'>
                    <mat-icon clzss="icon-delete">delete_outline
                    </mat-icon>
                  </a>
                </mat-cell>
              </ng-container>

              <!-- Header -->
              <mat-header-row *matHeaderRowDef="displayedRefundColumns"></mat-header-row>

              <!-- Row -->
              <mat-row *matRowDef="let row; columns: displayedRefundColumns;">
              </mat-row>

            </mat-table>
            <!-- END TABLE -->
          </div>

          <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
            <button mat-raised-button (click)='openRefundDialog(null)'>
              <mat-icon class='icon-add'>add_circle_outline</mat-icon>
            </button>
          </div>

        </mat-tab>

      </mat-tab-group>

    </mat-tab>

    <mat-tab *ngIf='_productService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>settings</mat-icon>
        <div>Configuração </div>
      </ng-template>

      <div class='tab-config'>
        <div class='tab-discount'>
          <mat-form-field class="select-discount" appearance="outline">
            <mat-label style='font-size:13px; margin-right: 10px;'>
              Produto com direito a desconto
            </mat-label>
            <mat-select [formControl]="productForm.controls.discount_product_id">
              <mat-option *ngFor="let product of allProducts" [value]="product.id"
                style=' padding-left: 10px; margin:0px;'>
                {{ product.name }}
              </mat-option>
            </mat-select>

          </mat-form-field>

          <mat-form-field class="width-discount" appearance="outline">
            <input matInput type="number" [formControl]="productForm.controls.discount_percent" placeholder="(%)"
              autocomplete="off">
          </mat-form-field>


          <button mat-raised-button (click)='addProductDiscount()'>
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>

        </div>

        <div class='check-container'>

          <div style="display: flex; flex-direction: row; justify-content:space-between; margin-top: 10px; ">

            <mat-select [formControl]='productForm.controls.part_of'
              style='width: 200px; margin: 0 25px 0 20px; padding:5px;  background-color: whitesmoke;'
              placeholder="Pertence a:">
              <mat-option *ngFor="let part of part_of_list" [value]="part.id">
                {{ part.name }}
              </mat-option>
            </mat-select>

            <span class="active-width">
              <mat-checkbox [formControl]="productForm.controls.available">
                Disponível
              </mat-checkbox>
            </span>

            <span class="active-width">
              <mat-checkbox [formControl]="productForm.controls.available_purchase">
                Exibir na Loja
              </mat-checkbox>
            </span>

            <span class="active-width">
              <mat-checkbox [formControl]="productForm.controls.available_schedule">
                Exibir a Programação
              </mat-checkbox>
            </span>

          </div>

          <div style="display: flex; flex-direction: row; justify-content:space-between; margin: 10px 0 0 20px; width: 900px;">

            <mat-form-field class="url-width" appearance="outline">
              <mat-label>URL Programação</mat-label>
              <input matInput type="text" [formControl]="productForm.controls.url_schedule"
                autocomplete="off">
            </mat-form-field>

            <button style='height: 35px; margin-left: 50px;' mat-raised-button (click)='updateChecks()' *ngIf="_productService.isEdit">
              <mat-icon class='icon-done'>check_circle_outline</mat-icon>
            </button>

          </div>

        </div>

        <div class='tab-requiriments_2'>
          <mat-form-field class="select-width" appearance="outline">

            <mat-label style='font-size:13px; margin-right:20px;'>
              Produtos que são pré-requisito
            </mat-label>

            <mat-select [ngModel]='selectedRequiredProduct_id' (ngModelChange)='selectRequiredProduct($event)'>
              <mat-option *ngFor="let product of allProducts" [value]="product.id"
                style=' padding-left: 10px; margin:0;'>
                {{ product.name }}
              </mat-option>
            </mat-select>

          </mat-form-field>

          <button mat-raised-button (click)='addRequirement()'>
            <mat-icon class='icon-add'>add_circle_outline</mat-icon>
          </button>

          <!-- TABLE -->
          <mat-table [dataSource]="_productService.productRequirementsDataSource" matSort matSortActive="event_name"
            style='height: 120px; overflow:auto; margin: 0;'>

            <!-- icon Column -->
            <ng-container matColumnDef="icon">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <mat-icon style='font-size:1.4em; color:rgba(0,0,0,.7);'>list</mat-icon>
              </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef> Produto </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.product_name }} </mat-cell>
            </ng-container>


            <!-- delete Column -->
            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='removeRequirement(element)' style='background-color: whitesmoke;'>
                  <mat-icon class="icon-delete">delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedRequirementsColumns"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedRequirementsColumns;">
            </mat-row>

          </mat-table>
          <!-- END TABLE -->

        </div>

      </div>

    </mat-tab>


    <mat-tab *ngIf='_productService.isEdit'>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>people</mat-icon>
        <div>Apoio</div>
      </ng-template>

      <div class='tab-content-banner'>

        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
          <button mat-raised-button (click)='openBannerDialog()'>
            <mat-icon class='icon-add'>add_circle_outline</mat-icon>
          </button>
        </div>

        <!-- TABLE -->
        <mat-table [dataSource]="sponsorsDataSource" style='height:440px; overflow:auto; margin: 0 0 10px 0;'>

          <!-- image -->
          <ng-container matColumnDef="image">
            <mat-header-cell *matHeaderCellDef>Imagem</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <ng-container>
                <img class='banner_image' [src]='element.image'>
              </ng-container>
            </mat-cell>
          </ng-container>

          <!-- Link Column -->
          <ng-container matColumnDef="link">
            <mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.link }}
            </mat-cell>
          </ng-container>

          <!-- type Column -->
          <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef> Tela </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.type }}
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='removeBannerSponsor(element)' style='background-color: whitesmoke;'>
                <mat-icon class="icon-delete">delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedSponsorColumns">
          </mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayedSponsorColumns;">
          </mat-row>

        </mat-table>
        <!-- END TABLE -->
      </div>


    </mat-tab>

  </mat-tab-group>

</div>